module.exports = __webpack_public_path__ + "static/media/placeholder.38b5701e.jpg";